// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bgvz0","option":"styles_option__1KlvN","selected":"styles_selected__HmXBn"};